import { useEffect } from 'react'

import { useTrackWalletConnected } from '@/data/wallet/multations/link-wallet'
import { getChainType, getGlobalData } from '@/utils'
import { WalletContextType } from '@/wallets/types'

const cachedWallet = new Map<string, number>()

export default function useTrackConnectedWallet(wallets: Record<string, WalletContextType>) {
  const { mutate } = useTrackWalletConnected()

  useEffect(() => {
    Object.values(wallets).forEach((wallet) => {
      const walletType = getChainType(wallet.network ?? '')
      if (!wallet?.isConnected || cachedWallet.get(wallet.address) || !walletType) return

      // call once per session
      cachedWallet.set(wallet.address, 1)
      mutate({
        wallet: wallet.address,
        walletType,
        metadata: getGlobalData(),
        walletName: (wallet.wallet?.walletName || wallet.wallet?.name || '').toUpperCase(),
      })
    })
  }, [wallets])
}
